import { Component } from '@angular/core';

@Component({
  selector: 'app-tamanho-fonte',
  templateUrl: './tamanho-fonte.component.html',
  styleUrls: ['./tamanho-fonte.component.css']
})
export class TamanhoFonteComponent {

}
